import { BaseEditItemStore } from "@leap4/frontend";
import { IOrganization } from "../../interfaces/IOrganization";

export class AddOrganizationStore extends BaseEditItemStore<IOrganization>{
    entityName: string = "Organization";
}
